import { FolderIconClosed } from '@/utils/icons';
import { PendingSpinner } from '../../PendingSpinner/PendingSpinner';
import type { INewFolder } from '../../hooks/useNewFolder';
import { RenameInput } from '../../RenameInput/RenameInput';
import styles from './DocumentTable.module.css';

interface INewFolderRowProps {
  newFolder: INewFolder;
  value: string;
  error: string | null;
  onChange: (value: string) => void;
  onCommit: () => void;
  onCancel: () => void;
}

/**
 * The folder being created, listed with the folder rows but not a FolderRow:
 * with no id there is nothing to open, drag, drop onto or right-click with, so
 * none of those handlers exist here rather than being disabled.
 */
export function NewFolderRow({ newFolder, value, error, onChange, onCommit, onCancel }: INewFolderRowProps) {
  const isCreating = newFolder.status === 'creating';

  return (
    <tr className={styles.row} aria-busy={isCreating ? true : undefined}>
      <td className={`${styles.td} ${styles.colName}`}>
        <span className={`${styles.nameCell} ${styles.folderNameCell}`}>
          <span className={styles.folderRowIcon}><FolderIconClosed size={16} /></span>
          <span>
            {isCreating ? (
              <span className={styles.docName}>
                {newFolder.name}
                <PendingSpinner />
              </span>
            ) : (
              <RenameInput value={value} error={error} onChange={onChange} onCommit={onCommit} onCancel={onCancel} />
            )}
          </span>
        </span>
      </td>
      <td className={`${styles.td} ${styles.colDesc}`} />
      <td className={`${styles.td} ${styles.colVersion}`} />
      <td className={`${styles.td} ${styles.colStatus}`} />
      <td className={`${styles.td} ${styles.colSize}`} />
      <td className={`${styles.td} ${styles.colUpdated}`} />
    </tr>
  );
}
